import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import { hydrate as emotionHydrate } from 'emotion';

// All css imports have to go here because the server renderer has no loader for .css files
import './reset.css';
import './general.css';

import { StartPage } from './components/StartPage';
import { setWindow } from './globals';

import polyfillObjectAssign from 'es6-object-assign';
polyfillObjectAssign.polyfill();

/* TODO
  1. Mapbox
  1. Sektion med bild och höger-block
  1. "preview"-läge

  1. switch from react to preact if possible
*/

setWindow(window);

// eslint-disable-next-line no-undef
const container = document.getElementById('root');

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production') {
  ReactDOM.render(
    <BrowserRouter>
      <StartPage />
    </BrowserRouter>,
    container
  );
} else {
  class GoogleAnalytics extends Component {
    componentDidMount() {
      window.ga('send', 'pageview');
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      const newLocation = nextProps.location;
      const locationChanged = newLocation !== this.props.location;
      if (window.ga && locationChanged) {
        window.ga('send', 'pageview');
      }
    }

    render() {
      return <StartPage />;
    }
  }

  // eslint-disable-next-line no-undef
  emotionHydrate(window.emotionIds);
  ReactDOM.hydrate(
    <BrowserRouter>
      <Route component={GoogleAnalytics} />
    </BrowserRouter>,
    container
  );
}



// WEBPACK FOOTER //
// ./app/index.js